// Static brand + service data for Kinjal's Beauty & Hair

export const SALON = {
  name: "Kinjal's Beauty & Hair",
  slogan: "Where Does Beauty Begin",
  tagline: "Luxury Beauty & Hair Services in Auckland",
  subTagline:
    "Professional threading, waxing, facials, hair treatments & skincare designed to make you feel confident and beautiful.",
  phoneDisplay: "021 035 1166",
  phoneTel: "+64210351166",
  whatsapp: "64210351166", // wa.me format (no +)
  email: "Kinjalmontu24@gmail.com",
  address: "27 Solar Rd, Glen Eden, Auckland 0602, New Zealand",
  hours: [
    { day: "Mon – Fri", time: "9:00 AM – 7:00 PM" },
    { day: "Saturday", time: "9:00 AM – 6:00 PM" },
    { day: "Sunday", time: "10:00 AM – 4:00 PM" },
  ],
  rating: { score: 4.9, count: 187 },
  socials: {
    instagram: "https://www.instagram.com/",
    facebook: "https://www.facebook.com/",
    google: "https://www.google.com/maps/search/?api=1&query=27+Solar+Rd+Glen+Eden+Auckland",
  },
  mapsEmbed:
    "https://www.google.com/maps?q=27+Solar+Rd,+Glen+Eden,+Auckland+0602,+New+Zealand&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=27+Solar+Rd+Glen+Eden+Auckland+0602",
};

export const SERVICE_CATEGORIES = [
  {
    id: "threading",
    label: "Threading",
    blurb: "Precision shaping with traditional threading craft.",
    image:
      "https://images.unsplash.com/photo-1519415387722-a1c3bbef716c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxleWVicm93JTIwdGhyZWFkaW5nJTIwYmVhdXR5JTIwc2Fsb258ZW58MHx8fHwxNzc4Mjc4MjU1fDA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Eyebrows", price: "$7" },
      { name: "Upper Lips", price: "$6" },
      { name: "Chin", price: "$6" },
      { name: "Side Burns", price: "$6" },
      { name: "Full Face", price: "$30" },
    ],
  },
  {
    id: "waxing",
    label: "Waxing",
    blurb: "Smooth, gentle waxing with premium aftercare.",
    image:
      "https://images.unsplash.com/photo-1761718210055-e83ca7e2c9ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBiZWF1dHklMjBzcGElMjBmYWNpYWwlMjBza2luY2FyZXxlbnwwfHx8fDE3NzgyNzgyMzN8MA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Half Legs", price: "$15" },
      { name: "Full Legs", price: "$30 – 35" },
      { name: "Full Arms", price: "$25 – 30" },
      { name: "Under Arms", price: "$10 – 15" },
      { name: "Bikini Line", price: "$20" },
      { name: "Brazilian", price: "$40" },
      { name: "Back Wax", price: "$15 – 20" },
      { name: "Tummy Wax", price: "$15" },
    ],
  },
  {
    id: "tint",
    label: "Tint",
    blurb: "Define and frame your eyes with luxe colour.",
    image:
      "https://images.unsplash.com/photo-1739981193097-5e4ff4e36608?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiZWF1dHklMjBzcGElMjBmYWNpYWwlMjBza2luY2FyZXxlbnwwfHx8fDE3NzgyNzgyMzN8MA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Eyebrow Tint", price: "$10" },
      { name: "Eyelash Tint", price: "$10" },
    ],
  },
  {
    id: "facials",
    label: "Facials",
    blurb: "Indulgent facials for a luminous, glowing complexion.",
    image:
      "https://images.unsplash.com/photo-1693004927824-f2623bbedc8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiZWF1dHklMjBzcGElMjBmYWNpYWwlMjBza2luY2FyZXxlbnwwfHx8fDE3NzgyNzgyMzN8MA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Clean Up", price: "$20" },
      { name: "Mini Facial", price: "$30" },
      { name: "Full Facial", price: "$40" },
      { name: "Fruit Facial", price: "$40" },
      { name: "Pearl Facial", price: "$40" },
      { name: "Gold Facial", price: "Enquire" },
      { name: "Diamond Facial", price: "Enquire" },
      { name: "Korean Glass Skin Facial", price: "Enquire" },
      { name: "Whitening Facial", price: "Enquire" },
    ],
  },
  {
    id: "premium",
    label: "Premium Facials",
    blurb: "Brand-curated luxury facial collections.",
    image:
      "https://images.pexels.com/photos/13068357/pexels-photo-13068357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    grouped: [
      {
        brand: "Lotus Facial",
        items: [
          { name: "Diamond", price: "$35" },
          { name: "Gold", price: "$35" },
        ],
      },
      {
        brand: "Nature's Facial",
        items: [
          { name: "Gentle Fruit", price: "$35" },
          { name: "Anti-Tan", price: "$40" },
          { name: "Diamond", price: "$40" },
          { name: "Gold", price: "$40" },
          { name: "Silver", price: "$40" },
        ],
      },
      {
        brand: "Shahnaz Husain",
        items: [
          { name: "Gold Facial", price: "$55" },
          { name: "Diamond Facial", price: "$55" },
        ],
      },
      {
        brand: "SSCPL",
        items: [{ name: "Diamond Facial", price: "$55" }],
      },
      {
        brand: "Rich Feel",
        items: [{ name: "Pearl Facial", price: "$55" }],
      },
      {
        brand: "Bio-Reach",
        items: [
          { name: "Hydra Facial", price: "$50" },
          { name: "Korean Glass Skin", price: "$60" },
        ],
      },
      {
        brand: "O3",
        items: [{ name: "Whitening Facial O3", price: "$55" }],
      },
      {
        brand: "Body & Add-ons",
        items: [
          { name: "Facial Bleaching", price: "$20" },
          { name: "Full Body Polish", price: "$65" },
          { name: "Body Massage", price: "$60" },
        ],
      },
    ],
  },
  {
    id: "hair",
    label: "Hair Care",
    blurb: "Shape, repair and elevate with expert hair rituals.",
    image:
      "https://images.unsplash.com/photo-1748603160865-6ff28ef3c601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxoZWFsdGh5JTIwaGFpciUyMHN0eWxpbmclMjBzYWxvbiUyMGVsZWdhbnR8ZW58MHx8fHwxNzc4Mjc4MjMyfDA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Hair Cut", price: "$15" },
      { name: "Style Cut", price: "$30" },
      { name: "Hair Spa", price: "$30" },
      { name: "Keratin Treatment", price: "$95" },
      { name: "Highlights", price: "$75" },
      { name: "Re-Growth (Root Color)", price: "$45" },
      { name: "Hair Wash & Straight", price: "$35" },
    ],
  },
];

// Flat list of bookable services (for booking dropdown)
export const ALL_BOOKABLE_SERVICES = [
  "Eyebrow Threading",
  "Full Face Threading",
  "Half Legs Wax",
  "Full Legs Wax",
  "Brazilian Wax",
  "Eyebrow / Eyelash Tint",
  "Clean Up Facial",
  "Full Facial",
  "Korean Glass Skin Facial",
  "Diamond Facial",
  "Gold Facial",
  "Hydra Facial (Bio-Reach)",
  "Whitening Facial (O3)",
  "Full Body Polish",
  "Body Massage",
  "Hair Cut / Style Cut",
  "Hair Spa",
  "Keratin Treatment",
  "Highlights",
  "Re-Growth (Root Color)",
  "Hair Wash & Straight",
  "Bridal Package — Enquire",
  "Other / Custom — Discuss",
];

export const WHY_US = [
  { title: "Affordable Luxury", desc: "Premium experience at honest, fair pricing.", icon: "Crown" },
  { title: "Experienced Beauticians", desc: "Years of expertise across every treatment.", icon: "Sparkles" },
  { title: "Premium Products", desc: "Trusted brands like Lotus, Shahnaz, O3 & more.", icon: "Gem" },
  { title: "Hygienic Environment", desc: "Spotless, sanitised tools and treatment beds.", icon: "ShieldCheck" },
  { title: "Personalised Care", desc: "Treatments tailored to your skin and hair.", icon: "Heart" },
  { title: "Relaxing Experience", desc: "A calm, soothing space to unwind in.", icon: "Flower2" },
  { title: "Modern Treatments", desc: "Korean Glass Skin, Hydra & Keratin therapies.", icon: "Wand2" },
  { title: "Friendly Service", desc: "Warm, welcoming team that listens to you.", icon: "Smile" },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1762181644026-57ab24fb2e4f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwaGFpciUyMHN0eWxpbmclMjBzYWxvbiUyMGVsZWdhbnR8ZW58MHx8fHwxNzc4Mjc4MjMyfDA&ixlib=rb-4.1.0&q=85", caption: "Silken hair styling" },
  { src: "https://images.unsplash.com/photo-1748603160865-6ff28ef3c601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxoZWFsdGh5JTIwaGFpciUyMHN0eWxpbmclMjBzYWxvbiUyMGVsZWdhbnR8ZW58MHx8fHwxNzc4Mjc4MjMyfDA&ixlib=rb-4.1.0&q=85", caption: "Glossy blowout" },
  { src: "https://images.unsplash.com/photo-1761718210055-e83ca7e2c9ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBiZWF1dHklMjBzcGElMjBmYWNpYWwlMjBza2luY2FyZXxlbnwwfHx8fDE3NzgyNzgyMzN8MA&ixlib=rb-4.1.0&q=85", caption: "Skincare facial" },
  { src: "https://images.unsplash.com/photo-1739981193097-5e4ff4e36608?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBiZWF1dHklMjBzcGElMjBmYWNpYWwlMjBza2luY2FyZXxlbnwwfHx8fDE3NzgyNzgyMzN8MA&ixlib=rb-4.1.0&q=85", caption: "Glow ritual" },
  { src: "https://images.unsplash.com/photo-1693004927824-f2623bbedc8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBiZWF1dHklMjBzcGElMjBmYWNpYWwlMjBza2luY2FyZXxlbnwwfHx8fDE3NzgyNzgyMzN8MA&ixlib=rb-4.1.0&q=85", caption: "Hydra treatment" },
  { src: "https://images.unsplash.com/photo-1519415387722-a1c3bbef716c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxleWVicm93JTIwdGhyZWFkaW5nJTIwYmVhdXR5JTIwc2Fsb258ZW58MHx8fHwxNzc4Mjc4MjU1fDA&ixlib=rb-4.1.0&q=85", caption: "Brow shaping" },
  { src: "https://images.pexels.com/photos/7195799/pexels-photo-7195799.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Salon interior" },
  { src: "https://images.pexels.com/photos/13068357/pexels-photo-13068357.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Premium spa space" },
  { src: "https://images.unsplash.com/photo-1770457732596-cdd592565d66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxzb2Z0JTIwcGluayUyMHNpbGslMjB0ZXh0dXJlJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzgyNzgyNjB8MA&ixlib=rb-4.1.0&q=85", caption: "Soft luxe textures" },
];

export const TESTIMONIALS = [
  {
    name: "Aarti S.",
    role: "Glen Eden, Auckland",
    rating: 5,
    text: "Excellent service and affordable prices. Kinjal made me feel so comfortable — my skin has never looked this good!",
    avatar: "https://i.pravatar.cc/120?img=47",
  },
  {
    name: "Priya M.",
    role: "Titirangi",
    rating: 5,
    text: "Very professional and friendly staff. The Korean glass skin facial is honestly worth every dollar.",
    avatar: "https://i.pravatar.cc/120?img=32",
  },
  {
    name: "Hannah R.",
    role: "Henderson",
    rating: 5,
    text: "Best beauty salon experience in Auckland. The keratin treatment transformed my hair completely.",
    avatar: "https://i.pravatar.cc/120?img=45",
  },
  {
    name: "Nisha K.",
    role: "New Lynn",
    rating: 5,
    text: "Loved my bridal package. Hygienic, calming and so detail-oriented. I keep recommending Kinjal to everyone.",
    avatar: "https://i.pravatar.cc/120?img=49",
  },
  {
    name: "Sophie L.",
    role: "West Auckland",
    rating: 5,
    text: "Threading is on another level here — neat, quick and lasts so long. The little tea after is such a sweet touch.",
    avatar: "https://i.pravatar.cc/120?img=44",
  },
];

export const FAQ = [
  {
    q: "Do I need to book in advance?",
    a: "We recommend booking ahead, especially on weekends. You can reserve via the form below, WhatsApp or by calling us directly.",
  },
  {
    q: "Where are you located?",
    a: "We are at 27 Solar Rd, Glen Eden, Auckland 0602. Free parking is available right outside the salon.",
  },
  {
    q: "Do you offer bridal packages?",
    a: "Yes — bespoke bridal packages including pre-wedding facials, hair, threading and full body polish. WhatsApp us for a quote.",
  },
  {
    q: "Which payment methods do you accept?",
    a: "We accept EFTPOS, contactless cards, cash and bank transfer. For larger packages, we can arrange a deposit.",
  },
  {
    q: "Are your products and tools hygienic?",
    a: "Absolutely. Wax pots, threading thread and tools are single-use or fully sanitised between every guest.",
  },
];

export const OFFERS = [
  {
    badge: "December Special",
    title: "Glow Combo",
    desc: "Korean Glass Skin Facial + Eyebrow Threading + Upper Lip — pamper your face for the season.",
    price: "$75",
    was: "$90",
  },
  {
    badge: "Bridal Edit",
    title: "Bridal Beauty Ritual",
    desc: "Pre-wedding facial trial, full body polish, hair spa & threading — tailored to your big day.",
    price: "From $180",
    was: "$220",
  },
  {
    badge: "Hair Heroine",
    title: "Repair & Shine",
    desc: "Keratin Treatment + Hair Spa + Style Cut — silk-smooth, frizz-free hair you can flaunt.",
    price: "$135",
    was: "$160",
  },
];
